/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Service_Access_TitleInputs */

const en_vault_service_access_title = /** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Access Instructions`)
};

const es_vault_service_access_title = /** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones de Acceso al Servicio`)
};

const fr_vault_service_access_title = /** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions d'accès au service`)
};

const de_vault_service_access_title = /** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anweisungen für den Servicezugang`)
};

const id_vault_service_access_title = /** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petunjuk Akses Layanan`)
};

/** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */
const ja_vault_service_access_title = en_vault_service_access_title;

/** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */
const zh_vault_service_access_title = en_vault_service_access_title;

/** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */
const ar_vault_service_access_title = en_vault_service_access_title;

/** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */
const it_vault_service_access_title = en_vault_service_access_title;

/** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */
const ru_vault_service_access_title = en_vault_service_access_title;

/** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */
const pt_vault_service_access_title = en_vault_service_access_title;

/** @type {(inputs: Vault_Service_Access_TitleInputs) => LocalizedString} */
const ko_vault_service_access_title = en_vault_service_access_title;

/**
* | output |
* | --- |
* | "Service Access Instructions" |
*
* @param {Vault_Service_Access_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_service_access_title = /** @type {((inputs?: Vault_Service_Access_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Service_Access_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_service_access_title(inputs)
	if (locale === "es") return es_vault_service_access_title(inputs)
	if (locale === "fr") return fr_vault_service_access_title(inputs)
	if (locale === "de") return de_vault_service_access_title(inputs)
	if (locale === "ja") return ja_vault_service_access_title(inputs)
	if (locale === "zh") return zh_vault_service_access_title(inputs)
	if (locale === "ar") return ar_vault_service_access_title(inputs)
	if (locale === "id") return id_vault_service_access_title(inputs)
	if (locale === "it") return it_vault_service_access_title(inputs)
	if (locale === "ru") return ru_vault_service_access_title(inputs)
	if (locale === "pt") return pt_vault_service_access_title(inputs)
	return ko_vault_service_access_title(inputs)
});